export class CallCenterTicketFileIntegrityOutDTO {
  valid!: boolean;
  missingFieldNames!: string[];
}
